import * as React from "react";
import { AlertCircle } from "lucide-react";
import { PageCard } from "@/components/AppFrame";

/**
 * Reusable error/empty state for the public surface.
 *
 * Used by every page when something goes wrong (invalid tenant, no
 * form configured, network down, etc). The design intent is to feel
 * calm rather than alarmed — parents under deadline pressure don't
 * need a red banner shouting at them.
 */
export function ErrorState({
  title,
  body,
  cta,
}: {
  title: React.ReactNode;
  body: React.ReactNode;
  cta?: React.ReactNode;
}) {
  return (
    <PageCard>
      <div className="flex flex-col items-start gap-3">
        <span
          aria-hidden
          className="bg-muted text-muted-foreground flex h-9 w-9 items-center justify-center rounded-md"
        >
          <AlertCircle className="h-4 w-4" />
        </span>
        <h1 className="text-foreground text-lg font-semibold tracking-tight">{title}</h1>
        <div className="text-muted-foreground text-sm">{body}</div>
        {cta && <div className="mt-2">{cta}</div>}
      </div>
    </PageCard>
  );
}
